// Port of api/fuel/app/classes/filter/template/games.php
// Returns the complete default filter state, and merges user-provided values over it.

var TEMPLATE = {
	source: {
		all: false,
		collection: false,
		ratings: false,
		plays: false,
		list: false,
		'list.sorted': false,
		other: []
	},
	languages: [],
	language: {
		dependency: { from: 1, to: 5 }
	},
	age: {
		official: { from: 2, to: 21 },
		community: { from: 2, to: 21 }
	},
	text: '',
	owners: [],
	ownersmin: 0,
	users: [],
	overload: false,
	random: 0,
	limit: 0,
	base: [],
	nested: 0,
	nestChild: 0,
	nestParent: 0,
	orphans: [],
	expansions: 1,
	unrated: 0,
	unplayed: 0,
	soloplayed: 0,
	commented: 0,
	nosort: false,
	status: {
		merge: 0,
		user: 0,
		game: 0,
		own: 1,
		prevowned: 0,
		fortrade: 0,
		want: 0,
		wishlist: 0,
		hasparts: 0,
		wantparts: 0,
		wanttoplay: 0,
		wanttobuy: 0,
		preordered: 0
	},
	worth: {
		value: { from: 0, to: 200 },
		play: { from: 0, to: 200 }
	},
	wishlist: {
		priority: { from: 1, to: 5 },
		comment: ''
	},
	games: {
		subset: [],
		include: [],
		exclude: [],
		whitelist: []
	},
	count: {
		exact: 0,
		nested: 1,
		official: { from: 1, to: 10 },
		recommended: { from: 1, to: 10 },
		best: { from: 1, to: 10 },
		whitelist: []
	},
	rating: {
		user: { from: 0, to: 10 },
		group: { from: 0, to: 10 },
		community: { from: 0, to: 10 }
	},
	year: { from: 1970, to: 2030 },
	firstyear: { from: 1970, to: 2030 },
	weight: { from: 0, to: 5 },
	duration: { from: 0, to: 360 },
	durations: { absolute: 0 },
	plays: { from: 0, to: 100 },
	comment: {
		text: '',
		date: { from: false, to: false }
	},
	bgg: {
		owners: { from: 0, to: 99999999 }
	},
	version: {
		name: '',
		worth: { from: 0, to: 99999 },
		size: {
			width: { from: 0, to: 9999 },
			length: { from: 0, to: 9999 },
			depth: { from: 0, to: 9999 },
			weight: { from: 0, to: 9999 },
			footprint: { from: 0, to: 99999999 }
		}
	},
	comments: { from: 0, to: 50 },
	rank: { from: 0, to: 1000 },
	threshold: {
		plays: 0,
		group: 0,
		community: 0,
		owners: 0,
		hours: 0,
		weight: 0,
		count: 0,
		language: 0,
		age: 0,
		notrecommended: 0
	},
	designers: [],
	publishers: [],
	artists: [],
	families: [],
	mechanics: [],
	subdomains: [],
	categories: [],
	tags: [],
	tagfamilies: [],
	sort: 'name',
	sortReverse: 0,
	disparity: {
		user: {
			group: { from: -10, to: 10 },
			community: { from: -10, to: 10 }
		},
		group: {
			community: { from: -10, to: 10 }
		}
	},
	play: {
		status: 0,
		outcome: 0,
		subset: [],
		group: 0,
		last: 0,
		first: 0,
		count: { from: 1, to: 10 },
		reports: { required: 0, text: '' },
		players: { required: [], together: 0 },
		duration: { from: 0, to: 360 },
		winpercent: { from: 0, to: 100 },
		users: { from: 0, to: 100 },
		nolocation: 0,
		locations: []
	},
	rated: {
		divisive: { from: 0, to: 2 },
		date: {
			user: { from: false, to: false },
			group: { from: false, to: false }
		}
	},
	collection: {
		added: { from: false, to: false },
		updated: { from: false, to: false },
		exclude: { own: false, prevowned: false },
		condition: '',
		parts: { text: '', mode: 'either' }
	},
	played: {
		type: 'sometime',
		period: 'custom',
		range: { from: false, to: false },
		first: { edition: false, from: false, to: false },
		sometime: { edition: false, from: false, to: false },
		last: { edition: false, from: false, to: false },
		never: { edition: false, from: false, to: false },
		context: { from: false, to: false }
	},
	trade: { type: 0, status: 'want' },
	inventory: {
		location: { text: '', exists: 0 }
	},
	advanced: {
		id: '',
		logic: 'and',
		rules: []
	},
	rules: []
}

// Deep merge: template is the base, values override where present
function deepMerge(template, values) {
	var result = {}
	var keys = Object.keys(template)

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i]

		if (values && values[key] !== undefined) {
			if (Array.isArray(template[key])) {
				// Arrays take the value directly, don't merge
				result[key] = values[key]
			} else if (template[key] !== null && typeof template[key] === 'object') {
				result[key] = deepMerge(template[key], values[key])
			} else {
				result[key] = values[key]
			}
		} else {
			if (Array.isArray(template[key])) {
				result[key] = template[key].slice()
			} else if (template[key] !== null && typeof template[key] === 'object') {
				result[key] = deepMerge(template[key], {})
			} else {
				result[key] = template[key]
			}
		}
	}

	return result
}

var Template = {

	// Get a fresh copy of the default template
	defaults: function() {
		return deepMerge(TEMPLATE, {})
	},

	// Fill a partial filter with defaults.
	// This is the equivalent of Template::run() in PHP.
	fill: function(values) {
		var filter = deepMerge(TEMPLATE, values || {})
		return Template.prepare(filter)
	},

	// Apply date period shortcuts (port of Games::prepare)
	prepare: function(filter) {
		if (filter.played && filter.played.period) {
			var now = new Date()
			var period = filter.played.period

			if (period === 'month.current') {
				filter.played.range.from = monthStart(now)
				filter.played.range.to = dateStart(monthEnd(now))
			} else if (period === 'month.last') {
				var lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1)
				filter.played.range.from = monthStart(lastMonth)
				filter.played.range.to = dateStart(monthEnd(lastMonth))
			} else if (period === 'week.current') {
				filter.played.range.from = weekStart(now)
				filter.played.range.to = dateStart(weekStart(now))
			} else if (period === 'week.last') {
				var lastWeek = new Date(now.getTime() - 7 * 86400000)
				filter.played.range.from = weekStart(lastWeek)
				filter.played.range.to = dateStart(weekEnd(lastWeek))
			} else if (period === 'year.current') {
				filter.played.range.from = yearStart(now)
				filter.played.range.to = dateStart(yearEnd(now))
			} else if (period === 'year.last') {
				var lastYear = new Date(now.getFullYear() - 1, 0, 1)
				filter.played.range.from = yearStart(lastYear)
				filter.played.range.to = dateStart(yearEnd(lastYear))
			}
		}

		// Propagate range to the active type
		if (filter.played && (filter.played.range.from || filter.played.range.to)) {
			var type = filter.played.type
			if (filter.played[type]) {
				filter.played[type].from = filter.played.range.from
				filter.played[type].to = filter.played.range.to
			}
			filter.played.context = {
				from: filter.played.range.from,
				to: filter.played.range.to
			}
		}

		return filter
	},

	// Check if a filter requires session-specific data (user rating, trade, etc.)
	session: function(filter) {
		return (
			filter.rating.user.from !== 0 ||
			filter.rating.user.to !== 10 ||
			filter.rated.date.user.from ||
			filter.rated.date.user.to ||
			filter.trade.type !== 0 ||
			filter.trade.status !== 'want'
		)
	}

}

// Date helpers (unix timestamps)
function monthStart(d) {
	return Math.floor(new Date(d.getFullYear(), d.getMonth(), 1).getTime() / 1000)
}
function monthEnd(d) {
	return Math.floor(new Date(d.getFullYear(), d.getMonth() + 1, 0).getTime() / 1000)
}
function weekStart(d) {
	var day = d.getDay()
	var diff = d.getDate() - day + (day === 0 ? -6 : 1) // Monday
	return Math.floor(new Date(d.getFullYear(), d.getMonth(), diff).getTime() / 1000)
}
function weekEnd(d) {
	return weekStart(d) + (6 * 86400)
}
function yearStart(d) {
	return Math.floor(new Date(d.getFullYear(), 0, 1).getTime() / 1000)
}
function yearEnd(d) {
	return Math.floor(new Date(d.getFullYear(), 11, 31).getTime() / 1000)
}
function dateStart(ts) {
	var d = new Date(ts * 1000)
	return Math.floor(new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime() / 1000)
}

export default Template
